var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA2Contactor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.65 25.71L59 42.88V69h-4V45H33v6h-6v18h-4V51h-6V35h6V7h4v28h6v6h19.24L40.72 28.29l3.93-2.58zM55 7v20h4V7h-4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A2_Contactor.fc46faea.svg";
export { SvgA2Contactor as ReactComponent };